<template>
    <div :class="[layout, 'shows-listing']">
        <div
            v-if="'list' === layout"
            class="shows-list-controls list-control"
        >
            <base-list-control
                v-for="sortOption in sortOptions"
                :key="sortOption.label"
                :class="`sort-${sortOption.label.toLowerCase()}`"
                :config="sortOption"
                :sort-by="sortBy"
                :is-reverse="isReverse"
                @change="value => $emit('change', value)"
            />
        </div>

        <div class="listing-items">
            <shows-item
                v-for="showsItem in items"
                :key="showsItem.id"
                :item="showsItem"
                :layout="layout"
                :hide-labels="hideLabels"
                :allowed-labels="allowedLabels"
                :size="layout === 'grid' ? 'large' : 'xsmall'"
                @remove-show="value => $emit('remove-show', value)"
            />
            <a
                v-if="layout === 'grid'"
                href="#"
                class="add-show-item item-link"
                @click.prevent="onCreateShow"
            >
                <i class="fal fa-plus" />
                <p class="text">
                    Add Show
                </p>
            </a>
        </div>
    </div>
</template>

<script>
import ShowsItem from './ShowsItem';
import { mapActions, mapMutations } from 'vuex';
import { ACTION } from '@/components/ShowModal/config';

export default {
    components: {
        ShowsItem,
    },

    props: {
        layout: {
            type: String,
            default: 'list',
        },
        items: {
            type: [Array, Object],
            default: () => [],
        },
        sortOptions: {
            type: Array,
            default: () => [],
        },
        sortBy: {
            type: String,
            default: '',
        },
        isReverse: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: null,
        },
        hasProShows: {
            type: Boolean,
            default: true,
        },
        hideLabels: {
            type: Boolean,
            default: false,
        },
        allowedLabels: {
            type: Array,
            default: null,
        },
    },

    methods: {
        ...mapActions('show/modal', {
            openShowModal: 'openModal',
        }),

        ...mapMutations('show/modal', {
            setShowModalAction: 'setAction',
        }),

        /**
         * Handles create show action.
         */
        onCreateShow() {
            this.setShowModalAction(ACTION.CREATE);
            this.openShowModal();
        },
    },
};
</script>
